import React, { useEffect, useState } from 'react'
import { Button, FontIcon, Tooltipped } from 'react-md'

import { getStartRow } from 'components/data-table/actions'
import { DataTableRequest } from 'components/data-table/types'
import { useAuth } from 'contexts/auth/auth-context'
import { Theme } from 'contexts/auth/types'

interface Props {
  request: DataTableRequest | undefined
  setRequest: (value: React.SetStateAction<DataTableRequest | undefined>) => void
  rowsPerPage: number
  total: number
}

const NavigateNext = ({ request, setRequest, rowsPerPage, total }: Props) => {
  const [disabled, setDisabled] = useState<boolean>(false)
  const { theme } = useAuth()

  useEffect(() => setDisabled(Math.min(total, getStartRow(request, rowsPerPage) - 1 + rowsPerPage) >= total), [total, request, rowsPerPage])

  return (
    <Tooltipped id='navigate_next' tooltip='Próximo' position='above'>
      <Button
        themeType='contained'
        theme={'clear'}
        buttonType='icon'
        disabled={disabled}
        style={
          disabled
            ? {}
            : theme === Theme.Dark
            ? { margin: 2, backgroundColor: '#424242', color: '#FFFFFF' }
            : { margin: 2, backgroundColor: '#E0E0E0', color: '#212121' }
        }
        onClick={() => {
          if (request)
            setRequest({
              ...request,
              pagination: {
                page: (request?.pagination.page ?? 1) + 1,
                length: rowsPerPage,
              },
            })
        }}>
        <FontIcon>navigate_next</FontIcon>
      </Button>
    </Tooltipped>
  )
}

export default NavigateNext
